import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  instructionsWrapper: {
    paddingTop: '30px',
    [theme.breakpoints.down]:{
      width: '280px',
      padding: '0px  10px  0px 10px'
      
    }
  },
  instructionItem: {
    display: 'flex',
    alignItems: 'self-start',
    padding: '18px 0px',
    [theme.breakpoints.down]:{
      // width: '100%',
      width: '280px',
    }
  },
  instructionText: {
    display: 'flex',
    padding: '0px 10px',
    alignItems: 'center',
    [theme.breakpoints.down]:{
      width: '100%',
       
      justifyContent: 'center',
      // paddingRight: '10px'
    }
  },
  listNumberMark: {
    minWidth: '24px',
    minHeight: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000000',
    color: '#FFFFFF',
    borderRadius: '50%',
    display: 'flex'
  },
  linkText: {
    backgroundColor: '#E2F5F8',
    padding: '10px',
    marginLeft: '20px',

  }
}));

export default useStyles;
